function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import useCookie, { getCookie } from 'react-use-cookie';
import { useEffect } from 'react';
var POLLING_INTERVAL = 500;

/**
 * A wrapper around 'react-use-cookie', but optionally uses a polling mechanism to
 * keep the cookie (as read from the browser) in sync with the state.
 *
 * This is necessary when the same cookie key is used in multiple places -- react-use-cookie
 * makes use of an in-memory React state to store the cookie value, which is not
 * synchronized with the actual cookie value in the browser.
 *
 * @see https://github.com/tylerwolff/useCookie/blob/master/index.js#L60
 */
export default function useCookieStore(key, initialValue) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    polling: true
  };
  var _useCookie = useCookie(key, initialValue),
    _useCookie2 = _slicedToArray(_useCookie, 3),
    item = _useCookie2[0],
    setItem = _useCookie2[1],
    removeItem = _useCookie2[2];
  useEffect(function () {
    if (options.polling) {
      setInterval(function () {
        setItem(getCookie(key, item));
      }, POLLING_INTERVAL);
    }
  }, [key, setItem, item, options.polling]);
  return [item, setItem, removeItem];
}